import React from 'react';
import { Snackbar, Alert } from '@askporter/component-library';
import type { ToastProviderToastProps } from '../../providers/providerTypes';

interface ExportToastSnackbarProps {
  toast: ToastProviderToastProps;
  closeToast: () => void;
}

/*
 * A reusable snackbar component used to display export-related toasts.
 * The ExportProvider owns the toast state and passes it here for rendering.
 */
export const ExportToastSnackbar: React.FC<ExportToastSnackbarProps> = ({ toast, closeToast }) => {
  const { open, children, onToastClose } = toast;

  const handleClose = (_?: unknown, reason?: string) => {
    if (reason === 'clickaway') return;

    closeToast();
    onToastClose?.();
  };

  if (!open) return null;

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      autoHideDuration={null}
      onClose={handleClose}
      data-testid={'export-completed-toast'}
      ClickAwayListenerProps={{ onClickAway: () => null }}
    >
      <Alert severity={'success'} onClose={() => handleClose(undefined, 'clickedClose')} sx={{ width: '100%' }}>
        {children}
      </Alert>
    </Snackbar>
  );
};
